module.exports = __webpack_public_path__ + "img/FI-Real-Estate.fb027b46.jpg";